<template>
  <div
    class="border border-blue-100 mt-3 bg-blue-50 px-3 py-3 rounded-md grid md:grid-cols-3 gap-4"
  >
    <div
      class="text-orange-500 font-semibold"
      v-if="beforeAmount > 0"
    >
      <div class="mr-3">MONTO ANTERIOR:</div>
      <div class="text-orange-500 font-bold">
        {{ money() }}{{ format(beforeAmount) }}
      </div>
    </div>
    <div
      class="text-green-600 font-semibold"
    >
      <div class="mr-3">MONTO ADICIONAL:</div>
      <div class="text-green-600 font-bold">
        {{ money() }}{{ format(totalPayableByCustomer) }}
      </div>
    </div>
    <div class="text-blue-600 font-semibold">
      <div class="mr-3">TOTAL ACTUAL:</div>
      <div class="text-blue-500 font-bold">
        {{ money() }}{{ format(total) }}
      </div>
    </div>
  </div>
</template>

<script>
import { money, format } from "@/publicjs/money";
import config from "/public/apis/config.json";
export default {
  name: "ComponentForTotalDetails",
  props: {
    iva: {
      type: Number,
      required: true,
    },
    subTotal: {
      type: Number,
      required: true,
    },
    total: {
      type: Number,
      required: true,
    },
    totalPayableByCustomer: {
      type: Number,
      required: true,
    },
    beforeAmount: {
      type: Number,
      required: true,
    },
  },
  setup() {
    return {
      money,
      format,
      config,
    };
  },
};
</script>
